import { getExecEndpoint } from '../../service/getExecEndpoint';
import { BqResponse } from '~/api/def/endpoints/types';
import { defaultServer } from '~/api/def/servers/defaultServer';

export const fundAnalyticsEndpoint = {
  server: defaultServer,
  path: 'fund',
  description: 'Fund Analytics',
};

const endpointDocumentFundAnalyticsExec =
  getExecEndpoint<FundAnalyticsEndpointDef>(fundAnalyticsEndpoint);

export const endpointFundAnalyticsGET = async (fundId?: string) =>
  endpointDocumentFundAnalyticsExec<'GET'>({
    method: 'GET',
    urlExtra: fundId ? `/${fundId}/analytics` : '/analytics',
  });

export type LineGraphEntry = {
  formattedDate: string;
  [key: string]: string | number;
};

export type pCompanyPieChartGraphEntry = {
  sectorId: string;
  sectorName: string;
  companyCount: number;
  totalValuation: number;
  currency: string;
};

export interface FundAnalyticsEndpointDef {
  endpoint: typeof fundAnalyticsEndpoint;
  methods: {
    GET: {
      response: FundAnalyticsResponseGET;
    };
  };
}

type FundAnalyticsResponseGET = BqResponse<{
  data: fundAnalyticsResponse;
}>;

export type fundAnalyticsResponse = {
  irrLineGraph: LineGraphEntry[];
  moicLineGraph: LineGraphEntry[];
  pCompanyPieChartGraph: pCompanyPieChartGraphEntry[];
  allFundNames: string[];
};

const endpointFundValuationEventExec =
  getExecEndpoint<FundValuationEventEndpointDef>(fundAnalyticsEndpoint);

export const endpointFundValuationEventPOST = async (
  fundId: string,
  payload: FundValuationEventPayload,
) =>
  endpointFundValuationEventExec<'POST'>({
    method: 'POST',
    payload: payload,
    urlExtra: `/${fundId}/valuation-event`,
  });

export const endpointFundValuationEventDELETE = async (
  fundId: string,
  valuationEventId: string,
) =>
  endpointFundValuationEventExec<'DELETE'>({
    method: 'DELETE',
    urlExtra: `/${fundId}/valuation-event/${valuationEventId}`,
  });

export interface FundValuationEventEndpointDef {
  endpoint: typeof fundAnalyticsEndpoint;
  methods: {
    POST: {
      payload: FundValuationEventPayload;
    };
    DELETE: {
      response: FundValuationEventDeleteResponse;
    };
  };
}

export type FundValuationEventPayload = {
  value: number;
  currency: string;
  valuationDate: Date | string;
};

type FundValuationEventDeleteResponse = BqResponse<{
  data: object;
}>;
